// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Heading, Text } from '@storylinerlabs/design';
import { useTranslation } from 'react-i18next';

// import types
import { SectionColorEnum, SectionColor } from '../../types';

// import components
import NewsletterForm from '../forms/NewsletterForm';
import Section from '../atoms/Section';

// import styles
import styles from './NewsletterSection.module.css';

// define component
const NewsletterSection: React.FunctionComponent<{
  bgColor?: SectionColor;
}> = ({ bgColor }) => {
  // init hooks
  const { t } = useTranslation('components');

  // render section
  return (
    <Section bgColor={bgColor}>
      <div className={styles['storyliner-newsletter-section-container']}>
        <div className={styles['storyliner-newsletter-section-header']}>
          <Heading alignment="center" isHyphenated={false} tag="h2">
            {t('NewsletterSection.title')}
          </Heading>
          <Text alignment="center">{t('NewsletterSection.intro')}</Text>
        </div>

        <NewsletterForm />
        <div className={styles['storyliner-newsletter-section-scribble']} />
      </div>
    </Section>
  );
};

NewsletterSection.defaultProps = {
  bgColor: 'white',
};

NewsletterSection.propTypes = {
  bgColor: PropTypes.oneOf(Object.values(SectionColorEnum)),
};

export default NewsletterSection;
